import { CircularProgress } from '@mui/material';

export const ButtonProgressSpinner = () => (
  <CircularProgress size={20} thickness={6} sx={{ color: 'accent.main' }} />
);
